import { ThemeEvents } from '@theme/events';

class VariantCustomText extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateText);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateText);
  }

  updateText = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newText = event.detail.data.html.querySelector(`variant-custom-text[data-product-id="${this.dataset.productId}"]`);
    
    if (!newText) return;

    if (this.innerHTML !== newText.innerHTML) {
      this.innerHTML = newText.innerHTML;
    }
  };
}

if (!customElements.get('variant-custom-text')) {
  customElements.define('variant-custom-text', VariantCustomText);
}
